import React from 'react';
import { Layout, Typography, Row, Col, Card, Button } from 'antd';
import { 
  AuditOutlined, 
  SolutionOutlined, 
  SafetyCertificateOutlined, 
  UserSwitchOutlined,
  FileDoneOutlined,
  LineChartOutlined,
  UnlockOutlined
} from '@ant-design/icons';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './ServicesPage.css';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const services = [
  {
    title: "PHC Registration",
    icon: <SafetyCertificateOutlined />,
    description: "Complete guidance through Punjab Health Commission's registration process from preparation to final assessment.",
    details: [
      "Category Identification",
      "Document Collection",
      "Portal Creation & Submission",
      "Give Application Number",
      "Certificate issue from PHC",
    ]
  },
  {
    title: "Provisional Licensing",
    icon: <SolutionOutlined />,
    description: "Complete guidance for obtaining your PHC provisional license with accurate documentation and compliance support.",
    details: [
      "Category Identification",
      "Document Collection",
      "Portal Creation & Submission",
      "Give portal ID",
      "Certificate issue from PHC",
    ]
  },
  {
    title: "Regular Licensing",
    icon: <AuditOutlined />,
    description: "We ensure a seamless upgrade to your regular PHC license by managing all compliance and documentation requirements.",
    details: [
      "Category Identification",
      "Document Collection",
      "Visiting field for indicators",
      "Complete the documentation",
      "Invite the PHC teams for inspection",
    ]
  },
  {
    title: "Desealing Support",
    icon: <UnlockOutlined />,
    description: "Expert support in fulfilling PHC conditions and documentation required for the desealing of your healthcare facility.",
    details: [
      "Case Review",
      "Advocate Assignment",
      "Documentation & Appeal Preparation",
      "Follow-up with PHC"
    ]
  },
  {
    title: "Complaint handling",
    icon: <FileDoneOutlined />,
    description: "We help clients file formal complaints against healthcare establishments with the Punjab Health Commission (PHC).",
    details: [
      "Complaint Assessment",
      "Document Preparation",
      "Submission & Representation",
      "Follow-Up with PHC"
    ]
  }
];

const ServicesPage = () => {
  return (
    <Layout className="layout">
      <Header />
      <Content className="services-content">
        {/* Hero Section */}
        {/* <div className="services-hero">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Title level={1} className="hero-title">Our Consultancy Services</Title>
            <Paragraph className="hero-text">
              Comprehensive support for healthcare facilities seeking Punjab Health Commission accreditation 
              and quality improvement.
            </Paragraph>
          </motion.div>
        </div> */}

        {/* All Services Section */}
        <div className="all-services-section">
          <Title level={1} className="section-title">Our Consultancy Services</Title>
          <Paragraph className="section-description">
            Comprehensive support for healthcare facilities seeking Punjab Health Commission accreditation 
              and quality improvement.
          </Paragraph> <br /><br />

          <Row gutter={[24, 24]} style={{ marginTop: 48 }}>
            {services.map((service, index) => (
              <Col xs={24} sm={12} md={8} key={index}>
                <motion.div
                  whileHover={{ y: -10 }}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <Card 
                    hoverable 
                    className="service-card"
                    cover={
                      <div className="service-icon-container">
                        {React.cloneElement(service.icon, { 
                          style: { fontSize: '32px', color: '#1890ff' } 
                        })}
                      </div>
                    }
                  >
                    <Card.Meta
                      title={service.title}
                      description={service.description}
                    />
                    <div className="service-details">
                      <ul>
                        {service.details.map((detail, i) => (
                          <li key={i}>{detail}</li>
                        ))}
                      </ul>
                    </div>
                    {/* <Button type="primary" block style={{ marginTop: 16 }}>
                      Learn More
                    </Button> */}
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </div>

        {/* Process Section */}
        <div className="process-section">
          <Title level={2} className="section-title">Our Proven Process</Title>
          <Row gutter={[48, 48]} align="middle" style={{ marginTop: 48 }}>
            <Col xs={24} md={12}>
              <div className="process-steps">
                {[
                  "Initial Consultation",
                  "Facility Assessment",
                  "Gap Analysis",
                  "Improvement Plan",
                  "Implementation",
                  "Mock Survey",
                  "Final Accreditation"
                ].map((step, index) => (
                  <motion.div 
                    key={index}
                    className="process-step"
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                  >
                    <div className="step-number">{index + 1}</div>
                    <div className="step-text">{step}</div>
                  </motion.div>
                ))}
              </div>
            </Col>
            <Col xs={24} md={12}>
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <Card bordered={false} className="process-image-card">
                  <div className="process-image" />
                </Card>
              </motion.div>
            </Col>
          </Row>
        </div>

        {/* CTA Section */}
        <div className="services-cta">
          <Title level={3}>Ready to Start Your PHC Accreditation Journey?</Title>
          <Paragraph>
            Contact us today for a free initial assessment of your facility's readiness.
          </Paragraph>
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <a href="/contact">
            <Button type="primary" size="large" style={{ marginTop: 24 }}>
              Request Consultation
            </Button>
            </a>
          </motion.div>
        </div>
      </Content>
      <Footer />
    </Layout>
  );
};

export default ServicesPage;